__turbopack_context__.v({
  "closeLink": "reset-module-scss-module__sZfpMW__closeLink",
});
